import { useMutation } from "@tanstack/react-query"

import { client } from "@/api"
import { useQueryClient } from "@tanstack/react-query"
import queryKeys from "@/api/queryKeys"

function useDeleteAdvertisement() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (advertisementId: number) =>
      client
        .delete(`/advertisements/${advertisementId}`)
        .then((response) => response.data),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: queryKeys.advertisements.list._def,
      })
    },
  })
}
export default useDeleteAdvertisement
